import React from 'react';
import { Box, Flex, Text, Button, Badge, Avatar, VStack } from '@chakra-ui/react';
import { FaUserTie } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const JobOpeningListItem = ({ job, fromInternship }) => {
  const navigate = useNavigate();
  return (
    <Box 
      bg="white" 
      borderRadius="lg" 
      boxShadow="sm" 
      p={4}
      cursor="pointer"
      onClick={() => navigate(`/job-details/${job.encoded_id}`, { state: { job, fromInternship: !!fromInternship } })}
    >
      <Flex 
        direction={{ base: "column", md: "row" }} 
        align={{ base: "stretch", md: "center" }} 
        justify={{ base: "flex-start", md: "center" }} 
        gap={{ base: 2, md: 8 }}
        w="100%"
      >
        {/* Left: Icon/avatar */}
        <Box display="flex" alignItems="flex-start" gap={4} flex="1">
          <Avatar 
            icon={<FaUserTie fontSize="1.5rem" />} 
            bgGradient="linear(to-tr, pink.400, purple.500)" 
            color="white" 
            size="lg" 
            mr={{ base: 0, md: 2 }} 
            mb={{ base: 2, md: 0 }}
            alignSelf={{ base: "center", md: "auto" }}
          />
          {/* Middle: Type + Title */}
          <VStack 
            align="flex-start" 
            spacing={1} 
            minW={{ base: "0", md: "220px" }} 
            maxW={{ base: "100%", md: "260px" }}
            w={{ base: "100%", md: "auto" }}
          >
            <Badge colorScheme={job.type === 'Fulltime' ? 'green' : job.type === 'Part-time' ? 'purple' : 'orange'} mb={0} fontSize="sm" fontWeight="semibold" bg="transparent" color={job.type === 'Fulltime' ? 'green.400' : job.type === 'Part-time' ? 'purple.400' : 'orange.400'}>
              {job.type}
            </Badge>
            <Text fontWeight="bold" fontSize="xl" color="black">{job.title}</Text>
          </VStack>
        </Box>

        {/* Middle: Location + Salary */}
        <VStack 
          align="center"
          spacing={1}
          w="100%"
          mt={{ base: 2, md: 0 }}
        >
          <Text color="gray.500" fontSize="md" wordBreak="break-word" textAlign="center">{job.location}</Text>
          <Text color="gray.400" fontSize="md" textAlign="center">
            {job.salary === 'Negotiable' || !job.salary ? 'Negotiable' : `${job.salary} BDT`}
          </Text>
        </VStack>

        {/* Details button */}
        <Button
          bg="#25575F"
          color="#E6FF3F"
          borderRadius="full"
          fontWeight="bold"
          px={6}
          _hover={{ bg: '#215560', color: '#E6FF3F' }}
          size="md"
          ml={{ base: 0, md: 4 }}
          mt={{ base: 2, md: 0 }}
          w={{ base: "100%", md: "auto" }}
          alignSelf={{ base: "stretch", md: "auto" }}
        >
          Details
        </Button>
      </Flex>
    </Box>
  );
};

export default JobOpeningListItem; 